import React from 'react';
import CTAButton from '../CTAButton';
import { useBreakpoint } from '@/hooks/use-mobile';
import { Link } from 'react-router-dom';
const HeroContent = () => {
  const {
    isMobile
  } = useBreakpoint();
  return <div className="text-center space-y-4 md:space-y-6 mb-8 md:mb-12 animate-fade-in-up">
      <div className="flex justify-center mb-1 mt-6 md:mt-4">
        <div className="inline-flex items-center gap-1.5 rounded-full bg-gradient-to-r from-[#FEE6D8] to-[#FEE6D8]/70 text-[#003a70] font-medium px-5 py-2.5 text-sm shadow-md border border-[#FEE6D8]/40 backdrop-blur-sm transition-all duration-300 hover:shadow-lg hover:scale-105 hover:bg-gradient-to-r hover:from-[#FEE6D8]/90 hover:to-[#FEE6D8]/60 relative my-[31px]">
          <span className="relative z-10 drop-shadow-sm">✨ Perfect For: Digital Agencies, Small Businesses, Content Creators ✨</span>
        </div>
      </div>
      
      <h1 className="text-3xl md:text-4xl lg:text-6xl font-bold text-brand-dark leading-tight max-w-4xl mx-auto">
        Build AI Tools in Minutes With No Coding Required.
      </h1>
      
      <p className="text-base md:text-lg lg:text-xl text-brand-gray max-w-[95%] sm:max-w-3xl mx-auto leading-relaxed">Empower your business with AI-powered assistants, chatbots, interactive forms, and automated workflows—all in one intuitive platform.</p>
      
      <div className={`flex flex-col sm:flex-row justify-center gap-3 md:gap-4 ${isMobile ? 'pt-2' : 'pt-4'}`}>
        <Link to="/pricing">
          <CTAButton variant="primary">
            30 Day Free Trial
          </CTAButton>
        </Link>
      </div>
    </div>;
};
export default HeroContent;